import { useEffect, useState } from "react";
import "./newUser.css";
import NaijaStates from "naija-state-local-government";
import Navbar from "../../components/navbar/Navbar";
import AuthService from "../../services/auth.service";
import AdminService from "../../services/admin.service";
import Preloader from "../../components/preloader/Preloader";

export default function NewUser() {
	const [fetching, setFetching] = useState(false);
	const [stateValue, setStateValue] = useState("");
	const [employmentLocation, setEmploymentLocation] = useState("");
	const [lga, setLga] = useState("");
	const [firstname, setFirstname] = useState("");
	const [lastname, setLastname] = useState("");
	const [othername, setOthername] = useState("");
	const [email, setEmail] = useState("");
	const [phone, setPhone] = useState("");
	const [staffnum, setStaffnum] = useState("");
	const [department, setDepartment] = useState("");
	const [jobTitle, setJobTitle] = useState("");
	const [grade, setGrade] = useState("");
	const [emplDate, setEmplDate] = useState("");
	const [pencom, setPencom] = useState("");
	const [nhf, setNhf] = useState("");
	const [dob, setDob] = useState("");
	const [gender, setGender] = useState("");
	const [roles, setRoles] = useState("");
	const [isActive, setIsActive] = useState();
	const [userRoles, setUserRoles] = useState([]);

	const fetchRoles = async () => {
		setFetching(true);
		let res = await AdminService.getAllRoles();
		const data = res.allRoles;
		setUserRoles(data);
		setFetching(false);
	};

	useEffect(() => {
		fetchRoles();
	}, []);

	const newUser = {
		firstname,
		lastname,
		middlename: othername,
		email,
		phone,
		staffnum,
		department,
		jobTitle,
		dateOfBirth: dob,
		gender,
		grade,
		stateOfOrigin: stateValue,
		localGovt: lga,
		employmentLocation,
		employmentDate: emplDate,
		pencomNumber: pencom,
		nhf,
		roles,
		active: isActive,
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		AuthService.register(newUser);
	};

	return (
		<>
			<Navbar />
			<div className="newUser">
				<h1 className="newUserTitle">New User</h1>
				<form className="userForm">
					<div className="newUserForm">
						<div className="newUserItem">
							<label>First Name</label>
							<input
								onChange={(e) => setFirstname(e.target.value)}
								type="text"
								placeholder="John"
							/>
						</div>
						<div className="newUserItem">
							<label>Last Name</label>
							<input
								onChange={(e) => setLastname(e.target.value)}
								type="text"
								placeholder="Smith"
							/>
						</div>
						<div className="newUserItem">
							<label>Other Name</label>
							<input
								onChange={(e) => setOthername(e.target.value)}
								type="text"
								placeholder="Ojo"
							/>
						</div>
						<div className="newUserItem">
							<label>Email</label>
							<input
								onChange={(e) => setEmail(e.target.value)}
								type="email"
								placeholder="john@gmail.com"
							/>
						</div>
						<div className="newUserItem">
							<label>Phone</label>
							<input
								onChange={(e) => setPhone(e.target.value)}
								type="text"
								placeholder="+234 123 456 78"
							/>
						</div>
						<div className="newUserItem">
							<label>Staff ID/Number</label>
							<input
								onChange={(e) => setStaffnum(e.target.value)}
								type="text"
								placeholder="UBEC-1234KCSKU"
							/>
						</div>
						<div className="newUserItem">
							<label>Department</label>
							<input
								onChange={(e) => setDepartment(e.target.value)}
								type="text"
								placeholder="Education Fund"
							/>
						</div>
						<div className="newUserItem">
							<label>Job Title</label>
							<input
								onChange={(e) => setJobTitle(e.target.value)}
								type="text"
								placeholder="Educational Planning and Research"
							/>
						</div>
						<div className="newUserItem">
							<label>Grade</label>
							<select
								onChange={(e) => setGrade(e.target.value)}
								className="newUserSelect"
								name="grade"
								id="grade"
							>
								<option value="09">09</option>
								<option value="10">10</option>
								<option value="11">11</option>
								<option value="12">12</option>
								<option value="13">13</option>
								<option value="14">14</option>
								<option value="15">15</option>
								<option value="16">16</option>
							</select>
						</div>
						<div className="newUserItem">
							<label>State of Origin</label>
							<select
								className="newUserSelect"
								value={stateValue}
								onChange={(e) => setStateValue(e.target.value)}
								onLoad={(e) => setStateValue(e.target.value)}
							>
								{NaijaStates.states().map((state) => (
									<option value={state} key={state}>
										{state}
									</option>
								))}
							</select>
						</div>
						<div className="newUserItem">
							<label>Local Government</label>
							<select
								className="newUserSelect"
								value={lga}
								onChange={(e) => setLga(e.target.value)}
							>
								{stateValue ? (
									NaijaStates.lgas(stateValue).lgas.map((lg) => (
										<option value={lg} key={lg}>
											{lg}
										</option>
									))
								) : (
									<option>Local Govt...</option>
								)}
							</select>
						</div>
						<div className="newUserItem">
							<label>Employment Location</label>
							<select
								className="newUserSelect"
								value={employmentLocation}
								onChange={(e) => setEmploymentLocation(e.target.value)}
								onLoad={(e) => setEmploymentLocation(e.target.value)}
							>
								{NaijaStates.states().map((state) => (
									<option value={state} key={state}>
										{state}
									</option>
								))}
							</select>
						</div>
						<div className="newUserItem">
							<label>Employment Date</label>
							<input onChange={(e) => setEmplDate(e.target.value)} type="date" />
						</div>
						<div className="newUserItem">
							<label>PENCOM Number</label>
							<input
								onChange={(e) => setPencom(e.target.value)}
								type="text"
								placeholder="PEN-853UNJB"
							/>
						</div>
						<div className="newUserItem">
							<label>NHF</label>
							<input
								onChange={(e) => setNhf(e.target.value)}
								type="text"
								placeholder="NHF-85JHHJNFB"
							/>
						</div>
						<div className="newUserItem">
							<label>Date of Birth</label>
							<input onChange={(e) => setDob(e.target.value)} type="date" />
						</div>
						<div className="newUserItem">
							<label>Gender</label>
							<div className="newUserGender outlineDiv">
								<input
									onChange={(e) => setGender(e.target.value)}
									type="radio"
									name="gender"
									id="male"
									value="male"
								/>
								<label htmlFor="male">Male</label>
								<input
									onChange={(e) => setGender(e.target.value)}
									type="radio"
									name="gender"
									id="female"
									value="female"
								/>
								<label htmlFor="female">Female</label>
								<input
									onChange={(e) => setGender(e.target.value)}
									type="radio"
									name="gender"
									id="others"
									value="others"
								/>
								<label htmlFor="others">Others</label>
							</div>
						</div>
						<div className="newUserItem">
							<label>Active</label>
							<div className="newUserGender outlineDiv">
								<input
									onChange={(e) => setIsActive(e.target.value)}
									type="radio"
									name="active"
									id="yes"
									value={true}
								/>
								<label htmlFor="Yes">Yes</label>
								<input
									onChange={(e) => setIsActive(e.target.value)}
									type="radio"
									name="active"
									id="no"
									value={false}
								/>
								<label htmlFor="No">No</label>
							</div>
						</div>
					</div>
					<div className="newUserRole">
						<label>Staff Role</label>
						<div className="outlineDiv newUserRoleInput">
							{userRoles.map((item) => (
								<span>
									<input
										onChange={(e) => setRoles(e.target.value)}
										type="radio"
										name="role"
										key={item._id}
										id={item.name}
										value={item.name}
									/>
									<label htmlFor="initiator">{item.name}</label>
								</span>
							))}
						</div>
					</div>
					<button onClick={handleSubmit} className="newUserButton">
						Create
					</button>
				</form>
			</div>
			{fetching && <Preloader text={"Fetching data"} />}
		</>
	);
}
